import { useMutation } from '@tanstack/react-query';
import {
  authFinalizePurchase,
  type AuthFinalizePurchaseInput,
  type AuthFinalizePurchaseResponse
} from '../api/private/authFinalizePurchase';
import { useToken } from '../contexts/TokenContext';

interface UseAuthFinalizePurchaseOptions {
  onSuccess?: (data: AuthFinalizePurchaseResponse) => void;
  onError?: (error: Error) => void;
}

export const useAuthFinalizePurchase = (options?: UseAuthFinalizePurchaseOptions) => {
  const { idToken } = useToken();

  return useMutation<AuthFinalizePurchaseResponse, Error, { uuid: string; params: AuthFinalizePurchaseInput }>({
    mutationFn: ({ uuid, params }: { uuid: string; params: AuthFinalizePurchaseInput }) => {
      if (!idToken) {
        throw new Error('No authentication token available');
      }
      return authFinalizePurchase(idToken, uuid, params);
    },
    onSuccess: options?.onSuccess,
    onError: options?.onError,
    retry: false, // Don't retry authentication-related requests
  });
};